import { graphql } from '../../../graphql/generated';

export const ASSIGNED_USERS_QUERY = graphql(`
  query AssignedUsersForDoctor($doctorId: String!, $page: Int!, $pageSize: Int!) {
    users(page: $page, pageSize: $pageSize, doctorId: $doctorId) {
      items {
        id
        username
        firstName
        lastName
        disabled
      }
    }
  }
`);
